"use strict";

var _regeneratorRuntime = require("/usr/src/app/www/node_modules/@babel/runtime/regenerator/index.js");

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloneArbitrary = void 0;

var NextArbitrary_1 = require("../../check/arbitrary/definition/NextArbitrary");

var NextValue_1 = require("../../check/arbitrary/definition/NextValue");

var symbols_1 = require("../../check/symbols");

var Stream_1 = require("../../stream/Stream");

var CloneArbitrary = /*#__PURE__*/function (_NextArbitrary_1$Next) {
  _inherits(CloneArbitrary, _NextArbitrary_1$Next);

  var _super = _createSuper(CloneArbitrary);

  function CloneArbitrary(arb, numValues) {
    var _this;

    _classCallCheck(this, CloneArbitrary);

    _this = _super.call(this);
    _this.arb = arb;
    _this.numValues = numValues;
    return _this;
  }

  _createClass(CloneArbitrary, [{
    key: "generate",
    value: function generate(mrng, biasFactor) {
      var items = [];

      if (this.numValues <= 0) {
        return this.wrapper(items);
      }

      for (var idx = 0; idx !== this.numValues - 1; ++idx) {
        items.push(this.arb.generate(mrng.clone(), biasFactor));
      }

      items.push(this.arb.generate(mrng, biasFactor));
      return this.wrapper(items);
    }
  }, {
    key: "canShrinkWithoutContext",
    value: function canShrinkWithoutContext(value) {
      if (!Array.isArray(value) || value.length !== this.numValues) {
        return false;
      }

      if (value.length === 0) {
        return true;
      }

      for (var index = 1; index < value.length; ++index) {
        if (!Object.is(value[0], value[index])) {
          return false;
        }
      }

      return this.arb.canShrinkWithoutContext(value[0]);
    }
  }, {
    key: "shrink",
    value: function shrink(value, context) {
      var _this2 = this;

      if (value.length === 0) {
        return Stream_1.Stream.nil();
      }

      return new Stream_1.Stream(this.shrinkImpl(value, context !== undefined ? context : [])).map(function (v) {
        return _this2.wrapper(v);
      });
    }
  }, {
    key: "shrinkImpl",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function shrinkImpl(value, contexts) {
      var _this3 = this;

      var its, cur;
      return _regeneratorRuntime.wrap(function shrinkImpl$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              its = value.map(function (v, idx) {
                return _this3.arb.shrink(v, contexts[idx])[Symbol.iterator]();
              });
              cur = its.map(function (it) {
                return it.next();
              });

            case 2:
              if (cur[0].done) {
                _context.next = 8;
                break;
              }

              _context.next = 5;
              return cur.map(function (c) {
                return c.value;
              });

            case 5:
              cur = its.map(function (it) {
                return it.next();
              });
              _context.next = 2;
              break;

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, shrinkImpl);
    })
  }, {
    key: "wrapper",
    value: function wrapper(items) {
      var cloneable = false;
      var vs = [];
      var contexts = [];

      for (var idx = 0; idx !== items.length; ++idx) {
        var s = items[idx];
        cloneable = cloneable || s.hasToBeCloned;
        vs.push(s.value);
        contexts.push(s.context);
      }

      if (cloneable) {
        CloneArbitrary.makeItCloneable(vs, items);
      }

      return new NextValue_1.NextValue(vs, contexts);
    }
  }], [{
    key: "makeItCloneable",
    value: function makeItCloneable(vs, shrinkables) {
      var _this4 = this;

      vs[symbols_1.cloneMethod] = function () {
        var cloned = [];

        for (var idx = 0; idx !== shrinkables.length; ++idx) {
          cloned.push(shrinkables[idx].value);
        }

        _this4.makeItCloneable(cloned, shrinkables);

        return cloned;
      };

      return vs;
    }
  }]);

  return CloneArbitrary;
}(NextArbitrary_1.NextArbitrary);

exports.CloneArbitrary = CloneArbitrary;